import script from "./DetailsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsContainer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__